import {
  AdditionalToggle,
  elementSize,
  addCustomClass,
  removeCustomClass,
} from "@soinproduction/kit";
import vars from "../_vars";

document.addEventListener("DOMContentLoaded", function () {
  const { header } = vars;
  const mobile = header.querySelector(".mobile");
  const heroSection = document.querySelector(".hero-section");

  window.additionalToggleInstance = new AdditionalToggle({
    overlay: "[data-overlay]",
    activeClass: "active",
    items: [
      {
        trigger: ".burger",
        target: ".mobile, .header__box",
        close: ".mobile close",
        scroll: false,
        beforeOpen: () => {
          elementSize(header, "header-height", "height");
          mobile.style.maxHeight = `${mobile.scrollHeight}px`;
        },

        beforeClose: () => {
          mobile.style.maxHeight = `0px`;
        },
      },
    ],
  });

  if (heroSection) {
    const selector = ".header__nav";
    const offset = 20;
    const mediaQuery = "(min-width:1025px)";

    const el = document.querySelector(selector);
    if (!el) return;

    const initial = {
      position: el.style.position || "",
      top: el.style.top || "",
      left: el.style.left || "",
      width: el.style.width || "",
      transform: el.style.transform || "",
      zIndex: el.style.zIndex || "",
    };

    let triggerY = 0;
    let isFixed = false;
    let ticking = false;
    const mql = window.matchMedia(mediaQuery);

    function computeTrigger() {
      const wasFixed = isFixed;
      if (wasFixed) unfix(true);

      const rect = el.getBoundingClientRect();
      triggerY = rect.top + window.scrollY - offset;

      if (wasFixed) fix(true);
    }

    function fix(keepLeftWidthOnly = false) {
      const rect = el.getBoundingClientRect();
      if (!keepLeftWidthOnly) {
        el.style.position = "fixed";
        el.style.top = offset + "px";
        isFixed = true;
      }
      el.style.left = rect.left + "px";
      el.style.width = rect.width + "px";
      el.style.transform = "none";
    }

    function unfix(silent = false) {
      isFixed = false;
      el.style.position = initial.position;
      el.style.top = initial.top;
      el.style.left = initial.left;
      el.style.width = initial.width;
      el.style.transform = initial.transform;
      el.style.zIndex = initial.zIndex;
    }

    function apply() {
      if (!mql.matches) {
        if (isFixed) unfix();
        return;
      }

      const scY = window.scrollY || 0;
      if (scY >= triggerY) {
        if (!isFixed) fix();
      } else {
        if (isFixed) unfix();
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        apply();
        ticking = false;
      });
    }

    function onResizeOrMedia() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        computeTrigger();
        apply();
        ticking = false;
      });
    }

    computeTrigger();
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResizeOrMedia, { passive: true });
    if (mql.addEventListener) {
      mql.addEventListener("change", onResizeOrMedia);
    } else if (mql.addListener) {
      mql.addListener(onResizeOrMedia);
    }
  } else {
    header.classList.add("mode");
  }

  (function () {
    const btn = document.querySelector(".up-btn");
    if (!btn) return;

    const toggleBtn = () => {
      btn.classList.toggle("active", window.scrollY > window.innerHeight * 0.5);
    };

    window.addEventListener("scroll", toggleBtn, { passive: true });
    window.addEventListener("resize", toggleBtn, { passive: true });

    toggleBtn();

    btn.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  })();

  (function() {
    const row   = document.querySelector(".case-row");
    const cards = document.querySelector(".case-cards");
    const grid  = document.querySelector(".case-grid");

    if (!row || !cards || !grid) return;

    const setActive = (el) => {
        [row, cards, grid].forEach(e => e.classList.remove("active"));
        if (el === row) {
        row.classList.add("active");
        cards.classList.add("active");
        } else if (el === grid) {
        grid.classList.add("active");
        }
    };

    setActive(grid);

    row.addEventListener("click", () => {
        if (!row.classList.contains("active")) setActive(row);
    });

    grid.addEventListener("click", () => {
        if (!grid.classList.contains("active")) setActive(grid);
    });
    })();

});
